import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-white text-black font-body flex items-center justify-center px-6" data-testid="payment-cancel-root">
      <div className="max-w-xl w-full border-2 border-black p-8 lg:p-12 shadow-brutal text-center">
        <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#E60000] mb-4">
          Payment cancelled
        </div>
        <h1 className="font-display text-5xl lg:text-6xl uppercase leading-[0.9]">
          No charge.<br />No pressure.
        </h1>
        <p className="mt-6 text-lg font-medium text-neutral-800">
          Nothing was charged to your card. Whenever you're ready, come back and try again.
          The book will still be here.
        </p>
        <Link
          to="/"
          data-testid="payment-cancel-home"
          className="mt-8 inline-flex items-center justify-center w-full h-12 bg-[#E60000] text-white border-2 border-black font-bold uppercase tracking-widest text-sm hover:bg-black transition-colors"
        >
          Back to The Last Bet Project
        </Link>
      </div>
    </div>
  );
}
